import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './CommercialInfo.css';
import { CommercialInfoReadyBusiness } from './internal/components/CommercialInfoReadyBusiness';
import { ICommercialInfoProps } from './types';

export const CommercialInfo: React.FC<ICommercialInfoProps> = props => {
  const {
    commercialInfo: { officeClassText, priceText, readyBusinessType, monthlyIncome },
  } = props;

  if (readyBusinessType && monthlyIncome) {
    return (
      <CommercialInfoReadyBusiness
        currency={monthlyIncome.currency}
        income={monthlyIncome.income}
        incomePeriod="мес."
      />
    );
  }

  return (
    <div className={styles['container']}>
      {!!officeClassText && <UIText2 color="gray60_100">{officeClassText}</UIText2>}
      {!!priceText && <UIText2 color="gray60_100">{priceText}</UIText2>}
    </div>
  );
};

CommercialInfo.displayName = 'CommercialInfo';
